// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___c7ad31b70ab16a5abf9","cls2":"News-cls2___771d0f4d7583b34cb26 News-cls1___c7ad31b70ab16a5abf9"};